import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';

import { Typography } from 'redpoints-front-components/index';
import { FileUploader } from 'redpoints-front-common/components';

import { testPurchaseSetEvidencesUrl } from '../../../actions/testPurchaseActions';
import { getTestPurchaseLinkInfoEvidencesUrl } from '../../../reducers/tasks/testPurchase';
import { translate } from '../../../helpers/languageHelper';

const TestPurchaseEvidences = ({
  evidencesUrl,
  testPurchaseSetEvidencesUrl,
}) => {
  const [fileList, setFilesList] = useState(null);

  useEffect(() => {
    if (!fileList) {
      const files = evidencesUrl.map(url => ({
        key: url,
        uid: url,
        url: url,
      }));
      setFilesList(files);
    }
  }, [evidencesUrl, fileList]);

  const handleFileUploadChange = uploadedFiles => {
    const newEvidencesUrl = uploadedFiles.map(({ key, name, url }) =>
      key != null ? url : name
    );

    testPurchaseSetEvidencesUrl({ evidencesUrl: newEvidencesUrl });
  };

  return (
    <>
      <Typography blockTypes={['title2']}>
        {translate('tasks.testPurchase.evidences.title')}
      </Typography>
      <FileUploader
        accept="application/pdf, image/jpeg, image/jpg, image/png"
        apiVersion="v2"
        fileList={fileList || []}
        listType="picture-card"
        multiple
        onChange={handleFileUploadChange}
        showUploadList
      />
    </>
  );
};

const mapStateToProps = state => ({
  evidencesUrl: getTestPurchaseLinkInfoEvidencesUrl(state),
});

export default connect(mapStateToProps, {
  testPurchaseSetEvidencesUrl,
})(TestPurchaseEvidences);
